.bg{position:absolute;}